import type { CheckinTrend, CoachGraphsView } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-818 punkt 2 — the F-04 trend client.
//
// Its own file rather than a line in clinician-api.ts: the patient screen is
// being rebuilt in parallel, and a one-function module is the change that
// cannot collide with that work.
//
// The endpoint chooses its shape from the caller's role in the JWT, so there
// is no role parameter here to get wrong.
export async function fetchCheckinTrend(
  patientId: string,
): Promise<CheckinTrend> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/checkin-trend`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401<CheckinTrend>(res);
}

// TES-1482 (TES-1458 §5, Ö-715) — the coach's wellbeing and weight graphs,
// from the series the patient and the doctor read. The server returns only
// what the question register grants the coach.
export async function fetchCoachGraphs(
  patientId: string,
): Promise<CoachGraphsView> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/coach-graphs`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401<CoachGraphsView>(res);
}
